// A dónde va la persona después de «Continuar con Google».
//
// El mismo botón sirve para entrar y para darse de alta, así que la respuesta de
// /auth/register es la que decide: quien acaba de nacer (o llegó a /register sin
// empresa) sigue al alta —empresa → licencia → pago—; quien ya tiene empresa, o
// reclamó una demo, entra directo a la plataforma.

/** Lo que el front necesita de la respuesta de /auth/register. */
export interface GoogleAuthResult {
  /** El usuario se creó en esta petición. */
  userCreated?: boolean;
  companyId?: string | null;
  /** Reclamó una cuenta de demostración: ya tiene compañía y no se cobra. */
  demoAccountId?: string;
  /**
   * Aceptó una invitación al equipo (CC-CONSOLE#1512): ya está dentro de esa
   * compañía; no crea empresa ni pasa por licencia o pago.
   */
  invitedCompanyId?: string;
  /**
   * Tenía contraseña y Firebase se la quitó al vincular Google (correo sin
   * verificar). El backend lo manda una sola vez.
   */
  passwordRemoved?: boolean;
  /**
   * Alta manual con correo + contraseña (CC-CONSOLE#1550): debe confirmar su
   * correo con el código antes de entrar (`/verificar`).
   */
  emailVerificationRequired?: boolean;
  /** El primer código ya salió al correo (`sent`) y cuándo se puede reenviar. */
  verificationCode?: { sent?: boolean; sentTo?: string; resendInSeconds?: number };
}

/** Ruta + estado para abrir /register directo en «Tu empresa». */
export const REGISTER_COMPANY_STEP = {
  pathname: "/register",
  state: { step: "company", method: "google" },
} as const;

/**
 * ¿Debe continuar al paso «Tu empresa» del alta?
 *
 * Desde el login sólo quien nació en esta petición: una cuenta que ya existía
 * sin empresa (p. ej. un admin de reseller) entra como siempre. Desde /register
 * la persona vino a darse de alta, así que basta con que no tenga empresa.
 */
export const needsCompanyStep = (
  result: GoogleAuthResult,
  from: "login" | "register",
): boolean => {
  if (result.demoAccountId || result.companyId) return false;
  return from === "register" || result.userCreated === true;
};
